import { TabProps } from '../../../../models/tab'
import './Tab.scss'

const Tab = (props: TabProps) => {
    const tabClass = 'tab'
    return (
        <div className={`${tabClass} ${props.active && 'active'}`} onClick={props.onClick}>
            {props.name}
        </div>
    )
}

export default Tab
